module.exports = __webpack_public_path__ + "img/gold-medal.07dc0f3f.png";